import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import { useState, useEffect } from 'react';
import { bookingDetails } from 'services/bookingService';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import Select from 'components/ui/Select';
import { jobStatusOptions } from 'utils/BookingStatus';
import { updateBookingJob } from 'services/bookingService';
import InfoRow from 'components/ui/InfoRow';

const BookingDetailsModal = ({ isOpen, onClose, booking, onEdit }) => {
  const [services, setServices] = useState([]);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState('');
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const selectedBusiness = useSelector((state) => state?.business.selectedBusiness);


  

  const getBookingDetails = async () => {
    if(!selectedBusiness) return;

    try {
      const response = await bookingDetails(selectedBusiness.businessId,booking.id, false, true, false, true);

      if(response.success){
        setServices(response.data.services || []);
        setNotes(response.data.notes || []);
      }
      
    } catch (error) {
      console.error('Error fetching booking details:', error);
      toast.error('Failed to load booking details. Please try again later.');
    }
  }

  const updateJobStatus = async () => {
    // Implement the logic to update job status here
    // You might need to call an API endpoint to update the status
    if(status === booking?.status && newNote.trim() === '') {
      toast.info('No changes to update.');
      return;
    }

    //Only allow job to be cancelled if there is a note
    if(status === 2 && newNote.trim() === '') {
      toast.warning('Note is required to cancel a job.');
      return;
    }

    const payload = {
      status: status,
      note: newNote.trim()
    };
    setIsLoading(true);

    const results = await updateBookingJob(selectedBusiness.businessId, booking.id, payload);

    if(results.success){
      toast.success('Job status updated successfully!');
      setNewNote('');
      onClose(booking.id,status);
    }
    else{
      toast.error(results.message || 'Failed to update job status. Please try again later.');
    }
    setIsLoading(false);

  }

  useEffect(() => {
    if (isOpen) {
      getBookingDetails();
      setStatus(booking?.status);
    }
  }, [isOpen]);

  if (!isOpen || !booking) return null;


  return (
    <div className="fixed inset-0 z-1002 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="fixed inset-0 bg-black/50 transition-opacity" onClick={onClose}></div>
        
        <div className="relative bg-card border border-border rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-3 border-b border-border">
            <div className="flex items-center space-x-4">
              <div>
                <h2 className="text-xl font-semibold text-foreground">Job Details</h2>
                {/* <div className="flex items-center space-x-3 mt-1">
                  <span className='inline-flex items-center px-3 py-1 rounded-full text-sm font-small bg-gray-400 text-slate-800'>
                    {booking.bookedItemDetails.registrationNo}, {booking.bookedItemDetails.name} {booking.bookedItemDetails.model}
                  </span>
                </div> */}
              </div>
            </div>
            <div className="flex items-center space-x-2">
              {/* <Button variant="outline" size="sm" onClick={() => onEdit(booking)}>
                <Icon name="Edit" size={16} className="mr-2" />
                Edit
              </Button> */}
              <Button variant="ghost" size="icon" onClick={onClose}>
                <Icon name="X" size={20} />
              </Button>
            </div>
          </div>

          {/* Content */}
          <div className="overflow-y-auto max-h-[calc(90vh-140px)]">
            <div className="p-6 space-y-8">
              <div className='bg-cyan-700 pt-3 pb-4 px-4 rounded text-white'>
                <div className='flex flex-col'>
                  <h3>Job Status</h3>
                  <Select
                    className="w-full border border-border rounded"
                    options={jobStatusOptions}
                    value={status}
                    onChange={(val)=>{setStatus(val)}}
                    placeholder="Change Job Status"
                  />
                </div>
              </div>
              <hr />
              {/* Contact Information */}
              <div className="space-y-4">
                <h3 className="text-lg font-medium text-foreground flex items-center">
                  <Icon name="ListChecks" size={20} className="mr-2" />
                  Booking Details
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <InfoRow icon="User" label="Customer" value={booking?.name+' '+booking?.surname} />
                  <InfoRow icon="Phone" label="Customer" value={booking?.contactNumber} />
                  <InfoRow icon="Car" label="Customer" value={booking.bookedItemDetails.colour+' '+booking.bookedItemDetails.name+' '+booking.bookedItemDetails.model} />
                  <InfoRow icon="ScanLine" label="Registration Number" value={booking?.bookedItemDetails.registrationNo} />
                </div>
              </div>

              {/* Permissions */}
              {services && services?.length > 0 && (
                <div className="space-y-1">
                  <h3 className="text-lg font-medium text-foreground flex items-center">
                    <Icon name="Cog" size={20} className="mr-2" />
                    Services
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                    {services?.map((service) => (
                      <div key={service.id} className="flex items-center space-x-2 p-2 bg-muted/50 rounded-md">
                        <Icon name="Check" size={14} className="text-success flex-shrink-0" />
                        <span className="text-sm text-foreground">
                          {service.serviceName}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Notes */}
              <div className="space-y-1">
                <h3 className="text-lg font-medium text-foreground flex items-center">
                  <Icon name="FileText" size={20} className="mr-2" />
                  Notes
                </h3>
                <div className="p-0 bg-muted/30 rounded-lg">
                <textarea value={newNote} onChange={(e)=> setNewNote(e.target.value)} placeholder='Add a new note' className='w-full border border-slate-200 rounded py-4 px-2 active:border-light focus:border-slate-200'>
                </textarea>
                </div>
              </div>
              

              {/* Activity Timeline */}
              {notes.length > 0 && (
              <div className="space-y-1">
                <h3 className="text-lg font-medium text-foreground flex items-center">
                  <Icon name="Clock" size={20} className="mr-2" />
                  Recent Notes
                </h3>
                <div className="space-y-3">
                  {notes?.map((note) =>(
                    <div key={note.id} className="flex items-center space-x-3 p-3 bg-muted/30 rounded-2xl border shadow-sm bg-card border-border">
                      <div className="w-2 h-2 bg-success rounded-full flex-shrink-0"></div>
                      <div className="flex-1">
                        <div className="text-sm font-medium text-foreground">{note.note}</div>
                        <div className="text-xs text-muted-foreground">
                          {new Date(note.created)?.toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })} by <span className='italic font-semibold'>{note.user}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)}
              
            </div>
          </div>

          {/* Footer */}
          <div className="flex flex-col md:flex-row items-center md:justify-between pt-2 md:p-6 h-20 md:h-10 border-t border-border bg-muted/30">
            <div className="text-sm text-muted-foreground">
              Last updated: {new Date(booking.updated)?.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
            <div className="flex w-full md:w-auto px-4 md:px-0 mt-1 md:mt-0 items-center justify-end md:justify-normal space-x-3">
              <Button variant="outline" onClick={onClose}>
                Close
              </Button>
              <Button onClick={() => updateJobStatus()} iconName="Edit" iconPosition="left" iconSize={16} loading={isLoading}>
                Update Job
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingDetailsModal;